import { msalInstance } from "@/index";
import { msalConfig } from "@/authentication/authConfig";

// Gets a token using the current msalContext.  This will fail if the user isn't logged in.
export const acquireToken = async (forceRefresh: boolean) => {
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    throw "The account you're attempting to issue a token for is not logged in.  Please force a login.";
  }

  // todo: cache this so we don't have to call every time.
  const request = {
    scopes: [msalConfig.scope],
    account: activeAccount || accounts[0],
    forceRefresh,
  };

  const result = await msalInstance.acquireTokenSilent(request);
  return result.accessToken;
};


